import CategoricalScheme from '../../CategoricalScheme';

const schemes = [
  {
    id: 'sparkColorsThree',
    label: 'SPARK Colors Three',
    colors: [
      '#FF0000',
      '#FF8500',
      '#7F7F7F',
      '#00FF59',
      '#00BFFF',
      '#3425FF',
      '#E762FF',
      '#B30000',
      '#C37507',
      '#00C143',
      '#DBC309',
      '#B2ECFF',
      '#0A0098',
      '#8802A0',
      '#BB6A70',
      '#D3D3D3',
      '#ECEBC5',
      '#755887',
      '#54B8D9',
      '#8D88D7',
      '#E3CAE7',
      '#FF9A9A',
      '#E9B58A',
      '#FFE100',
      '#9EFDBF',
      '#007FA9',
      '#FF007F',
      '#766100',
      '#007027',
      '#671614',
    ],
  },
].map(s => new CategoricalScheme(s));

export default schemes;
